import config from "../config.json";
import { apiClient, getAccessToken } from "./apiClient";

const GetScreens = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value == null || value === undefined) return;
        if (Array.isArray(value)) {
            value.forEach(v => params.append(key, v));
        } else {
            params.append(key, value);
        }
    });

    let url = `${config.API_URL}/screens`;
    if (params.toString()) url += `?${params.toString()}`;

    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const GetMapGroupScreens = async (queryParams) => {
    const token = await getAccessToken();
    queryParams = queryParams || {};
    const params = new URLSearchParams();

    Object.entries(queryParams).forEach(([key, value]) => {
        if (value == null || value === undefined) return;
        if (Array.isArray(value)) {
            value.forEach(v => params.append(key, v));
        } else {
            params.append(key, value);
        }
    });

    let url = `${config.API_URL}/map-group-screens`;
    if (params.toString()) url += `?${params.toString()}`;

    const headers = {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
    };

    try {
        return await apiClient.get(url, { headers, timeout: config.API_CONNECTION_TIMEOUT });
    } catch (error) { throw error; }
};

const ScreenService = {
    GetScreens,
    GetMapGroupScreens,
};

export default ScreenService;